import { render } from "./OverviewStep.vue?vue&type=template&id=605b9bd5&scoped=true"
import script from "./OverviewStep.vue?vue&type=script&lang=js"
export * from "./OverviewStep.vue?vue&type=script&lang=js"

import "./OverviewStep.vue?vue&type=style&index=0&id=605b9bd5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605b9bd5"]])

export default __exports__